import { inject, observer } from 'mobx-react'
import { Route, Routes } from 'react-router'
import { withRouterProps } from '../../utils'
import SendPasswordResetMail from './SendPasswordResetMail'
import ResetPasswordForm from './ResetPasswordForm'

function ResetPassword(props) {
  const { location } = props

  return (
    <Routes location={location}>
      <Route index element={<SendPasswordResetMail />} />
      <Route path='2' element={<ResetPasswordForm />} />
    </Routes>
  )
}

export default withRouterProps(inject('store')(observer(ResetPassword)))
